import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemUiAnnouncementBannerRoute: InvariantJiraRoute = {
	name: 'global-settings-system-ui-announcement-banner',
	path: '/jira/settings/system/ui/announcement-banner',
};
